(function () {
  
  
    const LOG_PREFIX = "[payment-options-block.custom]";
    if (window.__paymentOptionsCustomAlreadyStarted) {
      console.warn(LOG_PREFIX, "duplicate script execution skipped");
      return;
    }
    window.__paymentOptionsCustomAlreadyStarted = true;
    console.log(LOG_PREFIX, "script loaded2");
    const existingDbg = window.__poDbg;
    window.__poDbg = existingDbg && typeof existingDbg === "object" ? existingDbg : {};
    if (!Array.isArray(window.__poDbg.events)) window.__poDbg.events = [];
    function dbg(event, payload) {
      try {
        const rec = { t: new Date().toISOString(), event, payload: payload || {} };
        window.__poDbg.events.push(rec);
        console.log(LOG_PREFIX, event, payload || {});
      } catch (e) {
        console.warn(LOG_PREFIX, "dbg_failed", String(e));
      }
    }
    dbg("boot", { href: window.location.href, readyState: document.readyState });
    window.addEventListener("error", (e) => {
      dbg("window_error", {
        message: e.message || "",
        filename: e.filename || "",
        lineno: e.lineno || 0,
        colno: e.colno || 0,
      });
    });
  
    document.addEventListener(
      "submit",
      (event) => {
        const form = event.target && typeof event.target.closest === "function" ? event.target.closest("form") : null;
        if (!form) return;
        dbg("global_submit_seen", {
          action: form.getAttribute("action") || "",
          dataType: form.getAttribute("data-type") || "",
        });
      },
      true
    );
  
    document.addEventListener(
      "click",
      (event) => {
        const button = event.target && typeof event.target.closest === "function"
          ? event.target.closest("button[name='add'], input[name='add'][type='submit']")
          : null;
        if (!button) return;
        dbg("global_add_click_seen", {
          tag: button.tagName,
          id: button.id || "",
          cls: button.className || "",
        });
      },
      true
    );
  
    const MAX_RETRIES = 80;
    const RETRY_DELAY_MS = 250;
    let hasMounted = false;
  
    function formatMoney(cents) {
      try {
        const format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || "${{amount}}";
        const safeCents = typeof cents === "number" ? cents : Number(cents || 0);
        const amount = (safeCents / 100).toFixed(2);
        return format.replace("{{amount}}", amount).replace("{{ amount }}", amount);
      } catch (e) {
        return "$" + (Number(cents || 0) / 100).toFixed(2);
      }
    }
  
    function getMainVariantId() {
      const hiddenVariant = document.getElementById("pb_variant_id");
      if (hiddenVariant && hiddenVariant.value) return Number(hiddenVariant.value);
  
      const productFormVariant = document.querySelector(".product-form input[name='id']");
      if (productFormVariant && productFormVariant.value) return Number(productFormVariant.value);
  
      return null;
    }
  
    function getQuantity() {
      const qtyInput = document.querySelector(".product-form__quantity-selector input[type='number']");
      const qty = qtyInput ? Number(qtyInput.value) : 1;
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }
  
    function getFirstSellingPlanAllocation(allocations) {
      if (!Array.isArray(allocations) || !allocations.length) return null;
      for (let i = 0; i < allocations.length; i += 1) {
        const allocation = allocations[i];
        if (allocation && (allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id))) return allocation;
      }
      return null;
    }
  
    function normalizePlanId(planId) {
      if (planId === null || typeof planId === "undefined") return "";
      const raw = String(planId);
      const parts = raw.split("/");
      return parts[parts.length - 1] || raw;
    }
  
    function extractPlanIdFromAny(source) {
      if (!source) return null;
      if (typeof source === "string" || typeof source === "number") return source;
      if (source.selling_plan_id) return source.selling_plan_id;
      if (source.id) return source.id;
      if (source.selling_plan) {
        if (typeof source.selling_plan === "string" || typeof source.selling_plan === "number") return source.selling_plan;
        if (source.selling_plan.id) return source.selling_plan.id;
        if (source.selling_plan.selling_plan_id) return source.selling_plan.selling_plan_id;
      }
      return null;
    }
  
    function toCents(value) {
      if (typeof value === "number" && Number.isFinite(value)) return Math.round(value);
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return null;
        const numeric = trimmed.replace(/[^0-9.-]/g, "");
        if (!numeric) return null;
        const parsed = Number(numeric);
        if (!Number.isFinite(parsed)) return null;
        return numeric.includes(".") ? Math.round(parsed * 100) : Math.round(parsed);
      }
      if (value && typeof value === "object") {
        if (typeof value.cents === "number") return Math.round(value.cents);
        if (typeof value.amount === "number") return Math.round(value.amount);
        if (typeof value.amount === "string") return toCents(value.amount);
        if (typeof value.value === "number") return Math.round(value.value);
        if (typeof value.value === "string") return toCents(value.value);
      }
      return null;
    }
  
    function getSelectionKey(item) {
      if (!item || typeof item !== "object") return "";
      return String(item.source_key || item.uid || item.product_id || item.variant_id || "");
    }
  
    function normalizeBlocks(blocks = []) {
      return blocks
        .map((block, index) => {
          let addOns = Array.isArray(block.add_ons) ? block.add_ons : [];
  
          if (!addOns.length && Array.isArray(block.options)) {
            addOns = block.options
              .filter((opt) => Array.isArray(opt.add_ons))
              .reduce((acc, opt) => acc.concat(opt.add_ons), []);
          }
  
          addOns = addOns
            .filter((a) => !a.hidden && Array.isArray(a.products) && a.products.length)
            .map((a, addonIndex) => ({
              id: a.id || `addon-${index}-${addonIndex}`,
              title: a.title || a.label || "Choose oil",
              max_limit: Number(a.max_limit || 1),
              products: a.products.map((p, productIndex) => {
                const sellingPlanGroups = Array.isArray(p.selling_plan_groups) ? p.selling_plan_groups : [];
                const rawVariants = Array.isArray(p.variants) && p.variants.length ? p.variants : [p];
                const variants = rawVariants.map((v, variantIndex) => {
                  const variantSellingPlanAllocations = Array.isArray(v.selling_plan_allocations) ? v.selling_plan_allocations : [];
                  const firstVariantPlan = getFirstSellingPlanAllocation(variantSellingPlanAllocations);
                  const variantPrice = v && v.price_info && typeof v.price_info.price === "number" ? v.price_info.price : Number(v.price || 0);
                  return {
                    uid: String(v.variant_id || v.id || `pv-${addonIndex}-${productIndex}-${variantIndex}`),
                    variant_id: Number(v.variant_id || v.id || 0),
                    title: v.title || v.variant_title || "",
                    variant_title: v.variant_title || v.title || "",
                    available: v.available !== false,
                    price: Number.isFinite(variantPrice) ? variantPrice : 0,
                    selling_plan_allocations: variantSellingPlanAllocations,
                    default_selling_plan_id: v.og_selling_plan_id || (firstVariantPlan && firstVariantPlan.selling_plan && firstVariantPlan.selling_plan.id) || null,
                    subscription_price:
                      firstVariantPlan && typeof firstVariantPlan.price === "number"
                        ? firstVariantPlan.price
                        : (typeof v.fallback_subscription_price === "number" ? v.fallback_subscription_price : null),
                    subscription_plan_name:
                      firstVariantPlan && firstVariantPlan.selling_plan
                        ? firstVariantPlan.selling_plan.name
                        : (v.fallback_selling_plan_name || ""),
                  };
                });
  
                const requestedVariantId = Number(p.variant_id || p.id || 0);
                const selectedVariant =
                  variants.find((variant) => Number(variant.variant_id) === requestedVariantId) ||
                  variants[0] ||
                  null;
  
                const sourceProductId = Number(p.product_id || (p.main_product && p.main_product.id) || p.id || 0);
                const sourceKey = String(sourceProductId || p.id || `p-${addonIndex}-${productIndex}`);
  
                return {
                  uid: sourceKey,
                  source_key: sourceKey,
                  variant_id: selectedVariant ? Number(selectedVariant.variant_id || 0) : 0,
                  product_id: sourceProductId,
                  product_handle: p.product_handle || "",
                  image: p.image || null,
                  tags: Array.isArray(p.tags) ? p.tags : [],
                  sub_title: p.sub_title || "",
                  title: (p.main_product && p.main_product.title) || p.product_title || "Oil",
                  variant_title: selectedVariant ? selectedVariant.variant_title : (p.title || p.variant_title || ""),
                  available: selectedVariant ? selectedVariant.available !== false : p.available !== false,
                  price: selectedVariant ? selectedVariant.price : Number(p.price || 0),
                  selling_plan_allocations: selectedVariant ? selectedVariant.selling_plan_allocations : [],
                  selling_plan_groups: sellingPlanGroups,
                  default_selling_plan_id: selectedVariant ? selectedVariant.default_selling_plan_id : null,
                  subscription_price: selectedVariant ? selectedVariant.subscription_price : null,
                  subscription_plan_name: selectedVariant ? selectedVariant.subscription_plan_name : "",
                  variants,
                };
              }),
            }));
  
          return {
            id: block.id || `block-${index}`,
            title: block.label_title || block.section_title || block.title || "Choose your oils",
            addOns,
          };
        })
        .filter((b) => b.addOns.length > 0);
  
    }
  
    function mountPaymentOptionsApp(normalizedBlocks, upsellFilters, chooseScentPlaceholder) {
      const filters = Array.isArray(upsellFilters) ? upsellFilters : [];
      const defaultChooseScentPlaceholder =
        typeof chooseScentPlaceholder === "string" && chooseScentPlaceholder.trim()
          ? chooseScentPlaceholder.trim()
          : "Choose Scent";
      console.log(LOG_PREFIX, "mountPaymentOptionsApp", {
        blocksCount: Array.isArray(normalizedBlocks) ? normalizedBlocks.length : 0,
        filtersCount: filters.length,
      });
      const { createApp, ref, reactive, computed, onMounted, watch, nextTick } = window.Vue;
      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  
      const templateInDom = document.getElementById("paymentOptionsCustomRoot");
  
      createApp({
        name: "PaymentOptionsApp",
        setup() {
          const LOG_PREFIX = "[payment-options-block.custom]";
          const paymentOptionsData = ref({ blocks: normalizedBlocks });
          const currentActiveBlock = ref(normalizedBlocks[0].id);
          const AtcPayload = ref([]);
          const isSubmitting = ref(false);
          const errMsg = ref("");
          const successMsg = ref("");
          let addonSubmitTimer = null;
          let lastAddonSubmitAt = 0;
          const searchByAddonId = reactive({});
          const selectedByAddonId = reactive({});
          const blockEnabledById = reactive({});
          const dropdownOpenByAddonId = reactive({});
          const planDropdownOpenByAddonId = reactive({});
          const planVersionByAddonId = reactive({});
          const filterByAddonId = reactive({});
  
          paymentOptionsData.value.blocks.forEach((block) => {
            const isDefaultCheckedBlock =
              typeof block.id === "string" &&
              block.id.endsWith("-custom-payment-block");
            blockEnabledById[block.id] = isDefaultCheckedBlock;
            block.addOns.forEach((addon) => {
              searchByAddonId[addon.id] = "";
              selectedByAddonId[addon.id] = [];
              dropdownOpenByAddonId[addon.id] = false;
              planDropdownOpenByAddonId[addon.id] = false;
              planVersionByAddonId[addon.id] = 0;
              filterByAddonId[addon.id] = "";
            });
          });
  
          const activeBlock = computed(() => paymentOptionsData.value.blocks.find((b) => b.id === currentActiveBlock.value) || paymentOptionsData.value.blocks[0]);
  
          function filteredProducts(addon) {
            const query = (searchByAddonId[addon.id] || "").trim().toLowerCase();
            const filterTag = filterByAddonId[addon.id] || "";
            let list = addon.products;
  
            if (filterTag) {
              list = list.filter((p) => Array.isArray(p.tags) && p.tags.includes(filterTag));
            }
  
            if (!query) return list;
            return list.filter((p) => `${p.title} ${p.variant_title}`.toLowerCase().includes(query));
          }
  
          function getSelectedItem(addon, product) {
            const targetKey = getSelectionKey(product);
            return selectedByAddonId[addon.id].find((x) => getSelectionKey(x) === targetKey);
          }
  
          function hasSubscription(product) {
            return !!(getFirstSellingPlanAllocation(product.selling_plan_allocations) || product.default_selling_plan_id);
          }
  
          function isSelected(addon, product) {
            return !!getSelectedItem(addon, product);
          }
  
          function getPurchaseType(addon, product) {
            const selected = getSelectedItem(addon, product);
            if (selected && selected.purchase_type) return selected.purchase_type;
            return "ONE_TIME";
          }
  
          function getDefaultSelection(product) {
            const firstPlan = getFirstSellingPlanAllocation(product.selling_plan_allocations);
            const resolvedPlanId =
              product.default_selling_plan_id ||
              (firstPlan && firstPlan.selling_plan && firstPlan.selling_plan.id) ||
              null;
            return {
              uid: product.uid,
              source_key: product.source_key || product.uid,
              variant_id: product.variant_id,
              product_id: product.product_id,
              title: product.title,
              variant_title: product.variant_title,
              available: product.available,
              price: product.price,
              selling_plan_allocations: product.selling_plan_allocations,
              selling_plan_groups: product.selling_plan_groups,
              default_selling_plan_id: resolvedPlanId,
              purchase_type: "ONE_TIME",
              selling_plan_id: null,
              subscription_price: product.subscription_price,
              subscription_plan_name: product.subscription_plan_name,
              sub_title: product.sub_title || "",
              variants: Array.isArray(product.variants) ? product.variants : [],
            };
          }
  
          function findSelectionIndex(addon, product) {
            const key = getSelectionKey(product);
            return selectedByAddonId[addon.id].findIndex((x) => getSelectionKey(x) === key);
          }
  
          function selectProduct(addon, product) {
            if (!product.available) return;
            const blockForAddon = paymentOptionsData.value.blocks.find((b) => b.addOns.some((a) => a.id === addon.id));
            if (blockForAddon) blockEnabledById[blockForAddon.id] = true;
  
            const current = selectedByAddonId[addon.id];
            const maxLimit = Number(addon.max_limit || 1);
  
            if (maxLimit <= 1) {
              current.splice(0, current.length, getDefaultSelection(product));
              dropdownOpenByAddonId[addon.id] = false;
              planDropdownOpenByAddonId[addon.id] = false;
              console.log(LOG_PREFIX, "selectProduct", {
                addonId: addon.id,
                maxLimit,
                selectedVariantId: product.variant_id,
                selectedByAddonId: JSON.parse(JSON.stringify(selectedByAddonId)),
              });
              return;
            }
  
            const idx = findSelectionIndex(addon, product);
            if (idx >= 0) return;
            if (current.length >= maxLimit) return;
            current.push(getDefaultSelection(product));
            dropdownOpenByAddonId[addon.id] = false;
            planDropdownOpenByAddonId[addon.id] = false;
            console.log(LOG_PREFIX, "selectProduct", {
              addonId: addon.id,
              maxLimit,
              selectedVariantId: product.variant_id,
              selectedByAddonId: JSON.parse(JSON.stringify(selectedByAddonId)),
            });
          }
  
          function toggleSelection(addon, product) {
            if (Number(addon.max_limit || 1) <= 1) {
              selectProduct(addon, product);
              return;
            }
  
            if (!product.available) return;
            const blockForAddon = paymentOptionsData.value.blocks.find((b) => b.addOns.some((a) => a.id === addon.id));
            if (blockForAddon) blockEnabledById[blockForAddon.id] = true;
            const current = selectedByAddonId[addon.id];
            const idx = findSelectionIndex(addon, product);
            if (idx >= 0) {
              current.splice(idx, 1);
              return;
            }
            if (current.length >= addon.max_limit) return;
            current.push(getDefaultSelection(product));
            dropdownOpenByAddonId[addon.id] = false;
          }
  
          function setPurchaseType(addon, product, purchaseType) {
            if (!product.available) return;
            const current = selectedByAddonId[addon.id];
            const idx = findSelectionIndex(addon, product);
            const firstPlan = getFirstSellingPlanAllocation(product.selling_plan_allocations);
            const nextSellingPlanId = purchaseType === "SUBSCRIPTION" ? (product.default_selling_plan_id || (firstPlan && firstPlan.selling_plan && firstPlan.selling_plan.id) || null) : null;
            if (purchaseType === "SUBSCRIPTION" && !nextSellingPlanId) return;
  
            if (idx >= 0) {
              if (purchaseType === "SUBSCRIPTION") {
                current[idx] = applySelectedPlanMeta(current[idx], nextSellingPlanId);
              } else {
                current[idx].purchase_type = purchaseType;
                current[idx].selling_plan_id = null;
              }
              planDropdownOpenByAddonId[addon.id] = false;
              return;
            }
  
            if (current.length >= addon.max_limit) return;
            const next = getDefaultSelection(product);
            if (purchaseType === "SUBSCRIPTION") {
              current.push(applySelectedPlanMeta(next, nextSellingPlanId));
            } else {
              next.purchase_type = purchaseType;
              next.selling_plan_id = null;
              current.push(next);
            }
          }
  
          function getSellingPlans(product) {
            const allocations = Array.isArray(product.selling_plan_allocations) ? product.selling_plan_allocations : [];
            const groups = Array.isArray(product.selling_plan_groups) ? product.selling_plan_groups : [];
  
            function getAllocationPrice(planId) {
              const a = allocations.find(
                (x) => {
                  if (!x) return false;
                  const allocationPlanId = extractPlanIdFromAny(x);
                  return normalizePlanId(allocationPlanId) === normalizePlanId(planId);
                }
              );
              if (!a) return null;
              return (
                toCents(a.price) ??
                toCents(a.per_delivery_price) ??
                toCents(a.compare_at_price) ??
                toCents(a.checkout_charge_amount)
              );
            }
  
            if (groups.length > 0) {
              const plans = [];
              groups.forEach((group) => {
                const groupPlans = Array.isArray(group.selling_plans) ? group.selling_plans : [];
                groupPlans.forEach((plan) => {
                  const planId = plan && (plan.id || plan.selling_plan_id);
                  if (!planId) return;
                  plans.push({
                    id: planId,
                    name: (plan.name || plan.selling_plan_name) || "Deliver every month",
                    price: getAllocationPrice(planId),
                  });
                });
              });
              if (plans.length > 0) return plans;
            }
  
            return allocations
              .filter((a) => a && (a.selling_plan_id || (a.selling_plan && a.selling_plan.id)))
              .map((a) => {
                const planId = a.selling_plan_id || (a.selling_plan && a.selling_plan.id);
                let price = a.price;
                if (typeof price !== "number" && price && typeof price.amount === "string") price = Math.round(parseFloat(price.amount) * 100);
                return {
                  id: planId,
                  name: (a.selling_plan && a.selling_plan.name) || "Deliver every month",
                  price: typeof price === "number" ? price : null,
                };
              });
          }
  
          function getEffectivePlanId(product) {
            if (!product) return null;
            const plans = getSellingPlans(product);
            return product.selling_plan_id || product.default_selling_plan_id || (plans[0] && plans[0].id);
          }
  
          function getCurrentPlanId(addon) {
            const selected = selectedByAddonId[addon.id];
            if (!Array.isArray(selected) || !selected.length) return null;
            return getEffectivePlanId(selected[0]);
          }
  
          function getSelectedPlanName(addon, product) {
            const planId = getEffectivePlanId(product);
            if (!planId) return product.subscription_plan_name || "Deliver every month";
            const plans = getSellingPlans(product);
            const plan = plans.find((p) => normalizePlanId(p.id) === normalizePlanId(planId));
            return (plan && plan.name) || product.subscription_plan_name || "Deliver every month";
          }
  
          function getSubscriptionPrice(addon, product) {
            const planId = getEffectivePlanId(product);
            if (!planId) {
              if (typeof product.subscription_price === "number") return product.subscription_price;
              return product.price;
            }
            const plans = getSellingPlans(product);
            const plan = plans.find((p) => normalizePlanId(p.id) === normalizePlanId(planId));
            if (plan && typeof plan.price === "number") return plan.price;
            if (typeof product.subscription_price === "number") return product.subscription_price;
            return product.price;
          }
  
          function getSubscriptionDiscountPercent(addon, product) {
            const subPrice = getSubscriptionPrice(addon, product);
            const regularPrice = product.price;
            if (typeof subPrice !== "number" || typeof regularPrice !== "number" || regularPrice <= 0) return null;
            const percent = Math.round(((regularPrice - subPrice) / regularPrice) * 100);
            return percent > 0 ? percent : null;
          }
  
          function getProductVariants(product) {
            if (!product || !Array.isArray(product.variants)) return [];
            return product.variants;
          }
  
          function handleAddonVariantChange(addon, selectedProduct, variantIdRaw) {
            const current = selectedByAddonId[addon.id];
            if (!selectedProduct || !Array.isArray(current)) return;
            const variants = getProductVariants(selectedProduct);
            if (!variants.length) return;
  
            const nextVariantId = Number(variantIdRaw || 0);
            const pickedVariant =
              variants.find((variant) => Number(variant.variant_id) === nextVariantId) ||
              variants[0];
            if (!pickedVariant) return;
  
            const next = {
              ...selectedProduct,
              variant_id: pickedVariant.variant_id,
              variant_title: pickedVariant.variant_title || pickedVariant.title || "",
              available: pickedVariant.available !== false,
              price: pickedVariant.price,
              selling_plan_allocations: pickedVariant.selling_plan_allocations,
              default_selling_plan_id: pickedVariant.default_selling_plan_id || null,
              subscription_price: pickedVariant.subscription_price,
              subscription_plan_name: pickedVariant.subscription_plan_name || "",
              purchase_type: "ONE_TIME",
              selling_plan_id: null,
            };
  
            Object.keys(next).forEach((key) => {
              selectedProduct[key] = next[key];
            });
  
            const idx = findSelectionIndex(addon, selectedProduct);
            if (idx >= 0) {
              current[idx] = {
                ...current[idx],
                ...next,
              };
            }
            planDropdownOpenByAddonId[addon.id] = false;
            planVersionByAddonId[addon.id] = (planVersionByAddonId[addon.id] || 0) + 1;
          }
  
          function applySelectedPlanMeta(item, rawPlanId) {
            const plans = getSellingPlans(item);
            const picked =
              plans.find((p) => normalizePlanId(p.id) === normalizePlanId(rawPlanId)) ||
              plans[0] ||
              null;
            let resolvedPickedPrice = picked && typeof picked.price === "number" ? picked.price : null;
            if (resolvedPickedPrice === null && picked && picked.name && typeof item.price === "number" && item.price > 0) {
              const match = String(picked.name).match(/(\d{1,2})\s*%/i);
              if (match) {
                const pct = Number(match[1]);
                if (Number.isFinite(pct) && pct > 0 && pct < 100) {
                  resolvedPickedPrice = Math.round((item.price * (100 - pct)) / 100);
                }
              }
            }
            dbg("applySelectedPlanMeta", {
              rawPlanId,
              pickedPlanId: picked && picked.id ? picked.id : null,
              pickedPrice: resolvedPickedPrice,
              pickedName: picked && picked.name ? picked.name : "",
              beforeSellingPlanId: item && item.selling_plan_id ? item.selling_plan_id : null,
              beforeSubscriptionPrice: item && typeof item.subscription_price === "number" ? item.subscription_price : null,
            });
            console.log(LOG_PREFIX, "applySelectedPlanMeta", {
              rawPlanId,
              pickedPlanId: picked && picked.id ? picked.id : null,
              pickedPrice: resolvedPickedPrice,
              pickedName: picked && picked.name ? picked.name : "",
              beforeSellingPlanId: item && item.selling_plan_id ? item.selling_plan_id : null,
              beforeSubscriptionPrice: item && typeof item.subscription_price === "number" ? item.subscription_price : null,
            });
            const nextPlanId = rawPlanId || (picked && picked.id) || item.default_selling_plan_id || item.selling_plan_id || null;
            const next = {
              ...item,
              purchase_type: "SUBSCRIPTION",
              selling_plan_id: nextPlanId,
            };
            if (typeof resolvedPickedPrice === "number") next.subscription_price = resolvedPickedPrice;
            if (picked && picked.name) next.subscription_plan_name = picked.name;
            return next;
          }
  
          function setSellingPlan(addon, product, planId) {
            const current = selectedByAddonId[addon.id];
            if (!Array.isArray(current)) return;
            const idx = findSelectionIndex(addon, product);
            if (idx < 0) return;
            dbg("setSellingPlan_before", {
              addonId: addon.id,
              variantId: product.variant_id,
              planId,
              currentItem: current[idx]
                ? {
                    selling_plan_id: current[idx].selling_plan_id || null,
                    subscription_price: typeof current[idx].subscription_price === "number" ? current[idx].subscription_price : null,
                    price: typeof current[idx].price === "number" ? current[idx].price : null,
                  }
                : null,
            });
            console.log(LOG_PREFIX, "setSellingPlan:before", {
              addonId: addon.id,
              variantId: product.variant_id,
              planId,
              currentItem: current[idx]
                ? {
                    selling_plan_id: current[idx].selling_plan_id || null,
                    subscription_price: typeof current[idx].subscription_price === "number" ? current[idx].subscription_price : null,
                    price: typeof current[idx].price === "number" ? current[idx].price : null,
                  }
                : null,
            });
            const updated = applySelectedPlanMeta(current[idx], planId);
            selectedByAddonId[addon.id] = current.map((item, i) => (i === idx ? updated : item));
            planVersionByAddonId[addon.id] = (planVersionByAddonId[addon.id] || 0) + 1;
            dbg("setSellingPlan_after", {
              addonId: addon.id,
              variantId: product.variant_id,
              planId,
              updated: {
                selling_plan_id: updated.selling_plan_id || null,
                subscription_price: typeof updated.subscription_price === "number" ? updated.subscription_price : null,
                price: typeof updated.price === "number" ? updated.price : null,
              },
            });
            console.log(LOG_PREFIX, "setSellingPlan:after", {
              addonId: addon.id,
              variantId: product.variant_id,
              planId,
              updated: {
                selling_plan_id: updated.selling_plan_id || null,
                subscription_price: typeof updated.subscription_price === "number" ? updated.subscription_price : null,
                price: typeof updated.price === "number" ? updated.price : null,
              },
            });
          }
  
          async function selectPlanAndClose(addon, product, planId) {
            setSellingPlan(addon, product, planId);
            if (typeof nextTick === "function") await nextTick();
            planDropdownOpenByAddonId[addon.id] = false;
          }
  
          function togglePlanDropdown(addonId) {
            planDropdownOpenByAddonId[addonId] = !planDropdownOpenByAddonId[addonId];
          }
  
          function getDisplayPrice(addon, product) {
            const purchaseType = getPurchaseType(addon, product);
            if (purchaseType === "SUBSCRIPTION") {
              const selected = getSelectedItem(addon, product);
              const price = selected ? getSubscriptionPrice(addon, selected) : product.subscription_price;
              if (typeof price === "number") return price;
            }
            return product.price;
          }
  
          function hasSelectedAddons() {
            return Object.keys(selectedByAddonId).some((addonId) => Array.isArray(selectedByAddonId[addonId]) && selectedByAddonId[addonId].length > 0);
          }
  
          function isBlockEnabled(blockId) {
            return !!blockEnabledById[blockId];
          }
  
          function toggleBlock(block) {
            blockEnabledById[block.id] = !blockEnabledById[block.id];
            if (blockEnabledById[block.id]) return;
            block.addOns.forEach((addon) => {
              selectedByAddonId[addon.id] = [];
              dropdownOpenByAddonId[addon.id] = false;
              planDropdownOpenByAddonId[addon.id] = false;
              searchByAddonId[addon.id] = "";
            });
          }
  
          function toggleDropdown(addonId) {
            dropdownOpenByAddonId[addonId] = !dropdownOpenByAddonId[addonId];
          }
  
          function getSelectedLabel(addon) {
            const selected = selectedByAddonId[addon.id];
            if (Array.isArray(selected) && selected.length > 0) {
              const first = selected[0];
              return first.variant_title ? `${first.title} - ${first.variant_title}` : first.title;
            }
            return defaultChooseScentPlaceholder;
          }
  
          function getSelectedSubTitle(addon) {
            const selected = selectedByAddonId[addon.id];
            if (Array.isArray(selected) && selected.length > 0) {
              const first = selected[0];
              return first.sub_title || "";
            }
            return "";
          }
  
          function getSelectedVariantId(addon, product) {
            const selected = getSelectedItem(addon, product);
            return Number((selected && selected.variant_id) || (product && product.variant_id) || 0);
          }
  
          function buildAddonItems(quantity, mainVariantId) {
            const addonItems = [];
            Object.keys(selectedByAddonId).forEach((addonId) => {
              selectedByAddonId[addonId].forEach((p) => {
                if (!p.variant_id) return;
                if (mainVariantId && Number(p.variant_id) === Number(mainVariantId)) return;
                const item = { id: p.variant_id, quantity };
                if (p.purchase_type === "SUBSCRIPTION" && p.selling_plan_id) item.selling_plan = p.selling_plan_id;
                addonItems.push(item);
              });
            });
            console.log(LOG_PREFIX, "buildAddonItems", {
              quantity,
              mainVariantId,
              addonItems,
              selectedByAddonId: JSON.parse(JSON.stringify(selectedByAddonId)),
            });
            return addonItems;
          }
  
          function setFilter(addonId, filterTag) {
            filterByAddonId[addonId] = filterTag || "";
          }
  
          function clearFilter(addonId) {
            filterByAddonId[addonId] = "";
          }
  
          function mergeDuplicateItems(items) {
            const map = {};
            items.forEach((item) => {
              const key = `${item.id}::${item.selling_plan || ""}`;
              if (!map[key]) {
                map[key] = { id: item.id, quantity: item.quantity };
                if (item.selling_plan) map[key].selling_plan = item.selling_plan;
                return;
              }
              map[key].quantity += item.quantity;
            });
            return Object.keys(map).map((k) => map[k]);
          }
  
          function enforceSingleMainProduct(items, mainVariantId) {
            if (!mainVariantId) return items;
            const normalized = [];
            let hasMain = false;
            items.forEach((item) => {
              const isMainNoPlan = Number(item.id) === Number(mainVariantId) && !item.selling_plan;
              if (!isMainNoPlan) {
                normalized.push(item);
                return;
              }
              if (!hasMain) {
                normalized.push({ id: Number(mainVariantId), quantity: 1 });
                hasMain = true;
              }
            });
            if (!hasMain) normalized.unshift({ id: Number(mainVariantId), quantity: 1 });
            return normalized;
          }
  
          async function refreshCartUI(mainVariantId) {
            if (!(cart && typeof cart.renderContents === "function" && typeof cart.getSectionsToRender === "function")) {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              return;
            }
  
            const sectionIds = cart.getSectionsToRender().map((section) => section.id).join(",");
            const sectionsResponse = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionIds)}`, {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            });
  
            if (!sectionsResponse.ok) {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              return;
            }
  
            const sectionsData = await sectionsResponse.json();
            if (!sectionsData || typeof sectionsData !== "object") {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              return;
            }
  
            if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
  
            cart.renderContents({
              id: mainVariantId || null,
              sections: sectionsData,
            });
  
            const cartDrawerItems = cart.querySelector("cart-drawer-items");
            if (cartDrawerItems && cartDrawerItems.classList.contains("is-empty")) cartDrawerItems.classList.remove("is-empty");
            const drawerInner = cart.querySelector(".drawer__inner");
            if (drawerInner && drawerInner.classList.contains("is-empty")) drawerInner.classList.remove("is-empty");
          }
  
          function scheduleAddonAdd(source) {
            if (!hasSelectedAddons()) return;
            if (addonSubmitTimer) clearTimeout(addonSubmitTimer);
            addonSubmitTimer = setTimeout(() => {
              addonSubmitTimer = null;
              const now = Date.now();
              if (now - lastAddonSubmitAt < 500) {
                console.log(LOG_PREFIX, "addon add skipped by dedupe window", { source });
                return;
              }
              lastAddonSubmitAt = now;
              handleAddToCart(source);
            }, 180);
          }
  
          async function handleAddToCart(source) {
            if (isSubmitting.value) {
              console.log(LOG_PREFIX, "handleAddToCart skipped (already submitting)", { source });
              return;
            }
            errMsg.value = "";
            successMsg.value = "";
            isSubmitting.value = true;
  
            try {
              const mainVariantId = getMainVariantId();
              const quantity = getQuantity();
              let items = buildAddonItems(quantity, mainVariantId);
              items = mergeDuplicateItems(items);
  
              console.log(LOG_PREFIX, "handleAddToCart:start", {
                source: source || "unknown",
                mainVariantId,
                quantity,
                items,
              });
  
              if (!items.length) throw new Error("No products selected for add to cart.");
  
              const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items }),
              });
              const data = await response.json();
              console.log(LOG_PREFIX, "handleAddToCart:response", {
                status: response.status,
                ok: response.ok,
                data,
              });
              if (response.status !== 200) throw new Error((data && data.message) || "Failed to add products to cart.");
  
              successMsg.value = "Addon products added to cart.";
              await refreshCartUI(mainVariantId);
            } catch (err) {
              errMsg.value = (err && err.message) || "Failed to add addon products to cart.";
            } finally {
              isSubmitting.value = false;
            }
          }
  
          function syncAtcPayload() {
            AtcPayload.value = Object.keys(selectedByAddonId).reduce((acc, addonId) => {
              return acc.concat(selectedByAddonId[addonId]);
            }, []);
          }
  
          function hookMainAddToCart() {
            if (document.body.getAttribute("data-payment-addon-delegated-hooked") === "true") return;
            document.body.setAttribute("data-payment-addon-delegated-hooked", "true");
            console.log(LOG_PREFIX, "hookMainAddToCart attached");
  
            document.addEventListener(
              "submit",
              (event) => {
                const form = event.target && typeof event.target.closest === "function" ? event.target.closest("form") : null;
                if (!form) return;
  
                const action = String(form.getAttribute("action") || "");
                const isAddToCartForm =
                  action.includes("/cart/add") ||
                  form.getAttribute("data-type") === "add-to-cart-form" ||
                  form.matches(".product-form form");
  
                if (!isAddToCartForm) return;
                if (!hasSelectedAddons()) return;
                if (isSubmitting.value) return;
  
                // Let theme add the main product, then append selected addons.
                console.log(LOG_PREFIX, "submit intercepted", {
                  action,
                  isAddToCartForm,
                  selectedByAddonId: JSON.parse(JSON.stringify(selectedByAddonId)),
                });
                scheduleAddonAdd("submit");
              },
              true
            );
          }
  
          function hookAddButtonClicks() {
            if (document.body.getAttribute("data-payment-addon-click-hooked") === "true") return;
            document.body.setAttribute("data-payment-addon-click-hooked", "true");
            console.log(LOG_PREFIX, "hookAddButtonClicks attached");
  
            document.addEventListener(
              "click",
              (event) => {
                const button = event.target && typeof event.target.closest === "function"
                  ? event.target.closest("button[name='add'], input[name='add'][type='submit']")
                  : null;
                if (!button) return;
                if (!hasSelectedAddons()) return;
                if (isSubmitting.value) return;
  
                console.log(LOG_PREFIX, "add button click seen", {
                  tag: button.tagName,
                  id: button.id || "",
                  classes: button.className || "",
                  selectedByAddonId: JSON.parse(JSON.stringify(selectedByAddonId)),
                });
                scheduleAddonAdd("click");
              },
              true
            );
          }
  
          function hookCartUpdateAddons() {
            if (document.body.getAttribute("data-payment-addon-cartupdate-hooked") === "true") return;
            document.body.setAttribute("data-payment-addon-cartupdate-hooked", "true");
            if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") {
              console.warn(LOG_PREFIX, "cartUpdate hook unavailable, falling back to submit/click hooks");
              hookMainAddToCart();
              hookAddButtonClicks();
              return;
            }
  
            console.log(LOG_PREFIX, "hookCartUpdateAddons attached");
            subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
              if (!payload || payload.source !== "product-form") return Promise.resolve();
              if (!hasSelectedAddons()) return Promise.resolve();
              if (isSubmitting.value) return Promise.resolve();
              scheduleAddonAdd("cartUpdate");
              return Promise.resolve();
            });
          }
  
          watch(selectedByAddonId, syncAtcPayload, { deep: true });
  
          onMounted(() => {
            console.log(LOG_PREFIX, "vue onMounted");
            hookCartUpdateAddons();
            setTimeout(hookCartUpdateAddons, 700);
          });
  
          return {
            paymentOptionsData,
            upsellFilters: filters,
            currentActiveBlock,
            activeBlock,
            AtcPayload,
            searchByAddonId,
            selectedByAddonId,
            blockEnabledById,
            dropdownOpenByAddonId,
            planDropdownOpenByAddonId,
            planVersionByAddonId,
            filterByAddonId,
            isSubmitting,
            errMsg,
            successMsg,
            formatMoney,
            filteredProducts,
            isSelected,
            hasSubscription,
            getPurchaseType,
            setPurchaseType,
            getDisplayPrice,
            getSellingPlans,
            getCurrentPlanId,
            getSelectedPlanName,
            getSubscriptionPrice,
            getSubscriptionDiscountPercent,
            setSellingPlan,
            selectPlanAndClose,
            togglePlanDropdown,
            getProductVariants,
            handleAddonVariantChange,
            hasSelectedAddons,
            isBlockEnabled,
            toggleBlock,
            toggleDropdown,
            getSelectedLabel,
            getSelectedSubTitle,
            getSelectedVariantId,
            setFilter,
            clearFilter,
            upsellFilters: filters,
            selectProduct,
            toggleSelection,
          };
        },
        delimiters: ["${", "}"],
        template: templateInDom
          ? "#paymentOptionsCustomRoot"
          : '\
        <div class="payment-options-custom">\
          <div v-if="paymentOptionsData.blocks.length > 1" class="payment-options-custom__tabs">\
            <button\
              v-for="block in paymentOptionsData.blocks"\
              :key="block.id"\
              type="button"\
              :class="[\'payment-options-custom__tab\', { \'is-active\': currentActiveBlock === block.id }]"\
              @click="currentActiveBlock = block.id"\
            >\
              {{ block.title }}\
            </button>\
          </div>\
  \
          <div v-if="activeBlock" class="payment-options-custom__block">\
            <div v-for="addon in activeBlock.addOns" :key="addon.id" class="payment-options-custom__addon">\
              <div class="payment-options-custom__addon-head">\
                <h4>{{ addon.title }}</h4>\
                <small>Choose up to {{ addon.max_limit }}</small>\
              </div>\
  \
              <input\
                type="search"\
                class="payment-options-custom__search"\
                :placeholder="\'Search oils...\'"\
                v-model="searchByAddonId[addon.id]"\
              />\
  \
              <div class="payment-options-custom__products">\
                <div\
                  v-for="product in filteredProducts(addon)"\
                  :key="product.uid"\
                  :class="[\'payment-options-custom__product\', { \'is-selected\': isSelected(addon, product) }]"\
                  @click="toggleSelection(addon, product)"\
                >\
                  <span class="payment-options-custom__title">{{ product.title }}</span>\
                  <span v-if="product.variant_title" class="payment-options-custom__variant">{{ product.variant_title }}</span>\
                  <span class="payment-options-custom__price">{{ formatMoney(getDisplayPrice(addon, product)) }}</span>\
                  <div v-if="hasSubscription(product)" class="payment-options-custom__purchase-type">\
                    <button\
                      type="button"\
                      :class="[\'payment-options-custom__purchase-btn\', { \'is-active\': getPurchaseType(addon, product) === \'ONE_TIME\' }]"\
                      @click.stop="setPurchaseType(addon, product, \'ONE_TIME\')"\
                    >\
                      One-time\
                    </button>\
                    <button\
                      type="button"\
                      :class="[\'payment-options-custom__purchase-btn\', { \'is-active\': getPurchaseType(addon, product) === \'SUBSCRIPTION\' }]"\
                      @click.stop="setPurchaseType(addon, product, \'SUBSCRIPTION\')"\
                    >\
                      Subscription\
                    </button>\
                  </div>\
                </div>\
              </div>\
            </div>\
  \
            <div class="payment-options-custom__footer">\
              <p v-if="hasSelectedAddons()" class="payment-options-custom__hint">Selected oils will be added with the main Add to cart button.</p>\
              <p v-if="errMsg" class="payment-options-custom__error">{{ errMsg }}</p>\
              <p v-if="successMsg" class="payment-options-custom__success">{{ successMsg }}</p>\
            </div>\
          </div>\
        </div>\
        ',
      }).mount("#paymentBlocksApp");
    }
  
    function tryInit(attempt) {
      if (hasMounted) return;
  
      if (!window.Vue || typeof window.Vue.createApp !== "function") {
        if (attempt === 0) dbg("tryInit_vue_not_ready", {});
        if (attempt < MAX_RETRIES) {
          setTimeout(() => tryInit(attempt + 1), RETRY_DELAY_MS);
        } else {
          console.warn("[payment-options-block.custom] Vue is not loaded.");
        }
        return;
      }
  
      const mountEl = document.getElementById("paymentBlocksApp");
      if (!mountEl) {
        if (attempt === 0) dbg("tryInit_mount_not_found", {});
        if (attempt < MAX_RETRIES) setTimeout(() => tryInit(attempt + 1), RETRY_DELAY_MS);
        return;
      }
  
      const paymentOptionsDataObj = window.paymentOptionsDataObj || {};
      const sourceBlocks = Array.isArray(paymentOptionsDataObj.blocks) ? paymentOptionsDataObj.blocks : [];
      const blocks = normalizeBlocks(sourceBlocks);
      const upsellFilters = Array.isArray(paymentOptionsDataObj.upsell_filters) ? paymentOptionsDataObj.upsell_filters : [];
      const chooseScentPlaceholder =
        typeof paymentOptionsDataObj.choose_scent_placeholder === "string"
          ? paymentOptionsDataObj.choose_scent_placeholder
          : "";
  
      if (!blocks.length) {
        if (attempt === 0) dbg("tryInit_no_blocks", { hasDataObj: !!window.paymentOptionsDataObj });
        if (attempt < MAX_RETRIES) {
          setTimeout(() => tryInit(attempt + 1), RETRY_DELAY_MS);
        }
        return;
      }
  
      dbg("tryInit_mounting", { blocksCount: blocks.length });
      hasMounted = true;
      mountPaymentOptionsApp(blocks, upsellFilters, chooseScentPlaceholder);
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => tryInit(0));
    } else {
      tryInit(0);
    }
  })();
  